import React from 'react'
import { Classroom as ClassroomConstants } from '@constants'
import { useRoomState } from '@gopeerproject/web-kit'

import Toolbar from './components/Toolbar'
import { useClassroomState } from '../../hooks'
import Wrapper from './components/Wrapper'
import MainParticipant from './components/MainParticipant'
import ParticipantList from './components/ParticipantList'
import PlaygroundParticipant from './components/PlaygroundParticipant'
import { useClassroomEnv } from '../../../ClassroomEnv'
import LocalParticipant from './components/LocalParticipant'

const Media = () => {
  const { env } = useClassroomEnv()
  const { panels } = useClassroomState()
  const minimized = !!panels.length

  switch (env) {
    case ClassroomConstants.ENV.PLAYGROUND:
      return <PlayGroundMedia minimized={minimized} />
    case ClassroomConstants.ENV.CLASSROOM:
      return <ClassroomMedia minimized={minimized} />
    default:
      return null
  }
}

const PlayGroundMedia = ({ minimized }) => (
  <Wrapper minimized={minimized}>
    {minimized && <Toolbar />}
    <PlaygroundParticipant minimized={minimized} />
  </Wrapper>
)

const ClassroomMedia = ({ minimized }) => {
  const roomState = useRoomState()

  if (roomState === 'disconnected') return null

  return (
    <Wrapper minimized={minimized}>
      {minimized && <Toolbar />}
      {minimized && <LocalParticipant />}
      <MainParticipant minimized={minimized} />
      <ParticipantList />
    </Wrapper>
  )
}

export default Media
